<mat-card>
    <mat-card-header>
        <mat-card-title class="text-center">
            <img [alt]="companyName + ' Logo'" [src]="companyImg" class="w-25 mx-auto">
        </mat-card-title>
        <mat-card-subtitle>
            <h3>Password Reset</h3>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="passwordForm">
            <div class="flex-col">
                <mat-form-field appearance="outline" class="w-100" color="primary">
                    <mat-label>New Password</mat-label>
                    <input #password [type]="showpassword ? 'text' : 'password'" formControlName="password" matInput
                           maxlength="32"
                           minlength="8" required>
                    <button (click)="showpassword = !showpassword"
                            [matTooltip]="showpassword ? 'Show password' : 'Hide password'"
                            class="h-fit-content p0" mat-icon-button
                            matSuffix
                            type="button">
                        @if (!showpassword) {
                            <mat-icon color="accent">remove_red_eye
                            </mat-icon>
                        }
                        @if (showpassword) {
                            <mat-icon color="accent">highlight_off</mat-icon>
                        }
                    </button>
                    @if (passwordForm.controls['password'].hasError('required')) {
                        <mat-error class="errorMsg" (click)="password.focus()">
                            This field is required
                        </mat-error>
                    }
                    @if (passwordForm.controls['password'].hasError('minlength')) {
                        <mat-error class="errorMsg" (click)="password.focus()"
                                   [style.color]="community?.password_minimum_character_alert_colour_hex">
                            Password must be at least 8 characters long
                        </mat-error>
                    }
                    @if (passwordForm.controls['password'].hasError('maxlength')) {
                        <mat-error class="errorMsg" (click)="password.focus()">
                            Password must be at less than 32 characters long
                        </mat-error>
                    }
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100" color="primary">
                    <mat-label>Confirm New Password</mat-label>
                    <input #confirmPassword [type]="showConfirmPassword ? 'text' : 'password'"
                           formControlName="confirmPassword"
                           matInput required>
                    <button (click)="showConfirmPassword = !showConfirmPassword"
                            [matTooltip]="showConfirmPassword ? 'Show password' : 'Hide password'"
                            class="h-fit-content p0" mat-icon-button
                            matSuffix
                            type="button">
                        @if (!showConfirmPassword) {
                            <mat-icon color="accent">remove_red_eye
                            </mat-icon>
                        }
                        @if (showConfirmPassword) {
                            <mat-icon color="accent">highlight_off</mat-icon>
                        }
                    </button>
                    @if (passwordForm.controls['confirmPassword'].hasError('required')) {
                        <mat-error class="errorMsg" (click)="confirmPassword.focus()">
                            This field is required
                        </mat-error>
                    }
                    @if (confirmPassword.value && password.value && password.value != confirmPassword.value) {
                        <mat-hint (click)="confirmPassword.focus()"
                                  class="errorMsg">
                            Fields must match
                        </mat-hint>
                    }
                </mat-form-field>

                @if (community?.password_help_text_rendered) {
                    <div [innerHTML]="community?.password_help_text_rendered"
                         class="muted ck-editorControl">
                    </div>
                }
            </div>
        </form>
    </mat-card-content>
    <mat-card-actions class="text-center flex-space-around">
        <button (click)="resetPassword()"
                [disabled]="passwordForm.invalid || loading || password.value != confirmPassword.value"
                class="mx-auto my-10"
                color="primary" mat-flat-button type="submit">
            Update Password
            @if (loading) {
                <mat-icon>
                    <mat-spinner color="primary" width="40px"></mat-spinner>
                </mat-icon>
            }
        </button>
    </mat-card-actions>
</mat-card>
